/**
 * Gomitolo collection intro: collapse a long category description on phones.
 *
 * Progressive enhancement. The description stays in the page and in the markup (search engines and screen readers read all
 * of it); on a phone it is clamped to three lines and a "Leggi tutto" button expands it. Nothing happens without JavaScript,
 * on wider screens, or when the text already fits in three lines. Labels come from data attributes (theme locale keys).
 */
(function () {
  var script = document.currentScript;
  var moreLabel = (script && script.dataset.more) || 'Read more';
  var lessLabel = (script && script.dataset.less) || 'Read less';
  var phone = window.matchMedia('(max-width: 749px)');
  var intro = document.querySelector("[id$='__section'] .rte");
  if (!intro) return;

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'gomitolo-intro-toggle';
  button.hidden = true;
  button.setAttribute('aria-expanded', 'false');
  if (!intro.id) intro.id = 'gomitolo-collection-intro';
  button.setAttribute('aria-controls', intro.id);
  button.textContent = moreLabel;
  intro.insertAdjacentElement('afterend', button);

  function collapse() {
    intro.setAttribute('data-gomitolo-intro', 'collapsed');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel;
  }

  function expand() {
    intro.removeAttribute('data-gomitolo-intro');
    button.setAttribute('aria-expanded', 'true');
    button.textContent = lessLabel;
  }

  function evaluate() {
    if (!phone.matches) {
      intro.removeAttribute('data-gomitolo-intro');
      button.hidden = true;
      return;
    }
    // Clamp first, then see whether anything is actually hidden.
    collapse();
    var overflows = intro.scrollHeight > intro.clientHeight + 1;
    button.hidden = !overflows;
    if (!overflows) intro.removeAttribute('data-gomitolo-intro');
  }

  button.addEventListener('click', function () {
    if (button.getAttribute('aria-expanded') === 'true') {
      collapse();
      intro.scrollIntoView({ block: 'nearest' });
    } else {
      expand();
    }
  });

  if (phone.addEventListener) phone.addEventListener('change', evaluate);
  evaluate();
})();
